import {inject, Injectable, PLATFORM_ID, signal} from '@angular/core';
import {UserInterface} from '../types/auth/user.interface';
import {HttpClient} from '@angular/common/http';
import {isPlatformBrowser} from '@angular/common';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class AuthService {
  private httpClient = inject(HttpClient);
  private LS_USER_KEY = 'LS_USER_KEY';
  private platformId = inject(PLATFORM_ID);

  isLoggedIn = signal(
    this.isLocalStorageAvailable() && !!localStorage.getItem(this.LS_USER_KEY)
  );

  get user(): UserInterface | null {
    if (this.isLocalStorageAvailable()) {
      return JSON.parse(localStorage.getItem(this.LS_USER_KEY) || 'null');
    }
    return null;
  }

  isAdmin = signal(this.user?.email === environment.adminEmail);

  login(data: { email: string, password: string }):Observable<UserInterface> {
    return this.httpClient.post<UserInterface>('member/login', data);
  }

  signUp(data: { email: string, password: string, name: string, confirmPassword: string }):Observable<UserInterface> {
   return  this.httpClient.post<UserInterface>('member/create', data);
  }

  update(data: { email: string, password: string, name: string, confirmPassword: string }):Observable<UserInterface> {
    return this.httpClient.put<UserInterface>('member/update', data);
  }

  sendForgotPasswordEmail(email: string):Observable<any> {
    return this.httpClient.get('member/sendforgotpassword', {params: {email}});
  }

  newPasswordRecovery(token: string, password: string): Observable<any> {
    return this.httpClient.get('member/setnewpassword', {params: {token, password}});
  }

  logout() {
    if (this.isLocalStorageAvailable()) {
      localStorage.removeItem(this.LS_USER_KEY);
    }
    this.isAdmin.set(false);
    this.isLoggedIn.set(false);
  }

  saveUser(user: UserInterface) {
    this.setUserAdmin(user);
    if (this.isLocalStorageAvailable()) {
      localStorage.setItem(this.LS_USER_KEY, JSON.stringify(user));
      this.isLoggedIn.set(true);
    }
  }

  private isLocalStorageAvailable(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  private setUserAdmin(user: UserInterface) {
    this.isAdmin.set(user.email === environment.adminEmail);
  }
}
